import { ListTableStateTypes, ListTableActionTypes } from "./ListTable.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: ListTableStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const ListTableReducer = (
  state: ListTableStateTypes = INITIAL_STATE,
  action: any
): ListTableStateTypes => {
  switch (action.type) {
    case ListTableActionTypes.FETCH_ALL_LIST_TABLE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case ListTableActionTypes.FETCH_ALL_LIST_TABLE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ListTableActionTypes.FETCH_ALL_LIST_TABLE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ListTableActionTypes.FETCH_ALL_LIST_TABLE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case ListTableActionTypes.FETCH_ONE_LIST_TABLE:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case ListTableActionTypes.FETCH_ONE_LIST_TABLE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ListTableActionTypes.FETCH_ONE_LIST_TABLE_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case ListTableActionTypes.FETCH_ONE_LIST_TABLE_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default ListTableReducer;
